/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import styles from './NavigationBar.module.css';
import { Section } from '../../App';

const NavigationBar = ({ pageIDs }: { pageIDs: Section[] }) => {
  const [activeSection, setActiveSection] = useState<Section>();
  const [scrolled, setScrolled] = useState(false);

  const scrollToSection = (id?: string | '') => {
    if (!id) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(id);
      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      let currentSection: Section = '';

      for (const id of pageIDs) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = id as Section;
            break;
          }
        }
      }

      setActiveSection(currentSection);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pageIDs]);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 60);
    };
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const ConnectIcon = ({ icon, tip }: { icon: any; tip: string }) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleClick = () => {
      const handleCopy = () => {
        setIsCopied(true);
        return navigator.clipboard.writeText('akhan1gfe@gmail.com');
      };

      return tip === "Let's connect"
        ? window.open(
            'https://www.linkedin.com/in/aman-khan-4ba984185/',
            '_blank',
            'noopener,noreferrer'
          )
        : handleCopy();
    };

    return (
      <div className={styles.iconContainer} onClick={handleClick}>
        {icon}
        <span className={styles.iconTooltip}>{isCopied ? 'Copied' : tip}</span>
      </div>
    );
  };

  return (
    <div className={`${styles.mainContainer} ${scrolled ? styles.shrunk : ''}`}>
      <div className={styles.navigationBarContainer}>
        <span className={styles.logo} onClick={() => scrollToSection()}>
          <span>A</span>
        </span>

        <ul className={styles.barContainer}>
          {pageIDs.map((page) => {
            return (
              <li
                key={page}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(page);
                }}
                className={`${styles.barItem} ${
                  activeSection === page ? styles.active : ''
                }`}
              >
                {page.charAt(0).toLocaleUpperCase()}
                {page.slice(1)}
              </li>
            );
          })}
        </ul>
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.headerIconTitle}>
          <h1 className={styles.contentTitle}>Hi, i'm Aman. </h1>
          <ConnectIcon
            icon={
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M8 11v5" />
                <path d="M8 8v.01" />
                <path d="M12 16v-5" />
                <path d="M16 16v-3a2 2 0 1 0 -4 0" />
                <path d="M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z" />
              </svg>
            }
            tip="Let's connect"
          />

          <ConnectIcon
            icon={
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
                <path d="M3 7l9 6l9 -6" />
              </svg>
            }
            tip="Email me :)"
          />
        </div>
        <p className={styles.contentSubtext}>
          I build modern, performance-driven web and mobile applications, with a
          focus on scalable architecture and seamless user interactions. My work
          bridges design and engineering, helping teams turn ideas into
          intuitive, production-ready solutions.
        </p>
      </div>
    </div>
  );
};

export default NavigationBar;
